export default __webpack_public_path__ + "static/media/kpsg_upscaled.82ac4e56.png";